import { queryOptions, useMutation, useQuery } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { CreateProjectType } from '../schema/create-project';
import type { Tenant } from './tenant';

type CreateTenantProjectOptions = {
  mutationConfig?: MutationConfig<typeof createTenantProject>;
};

export const getTenantProjects = (id: Tenant['id']) => {
  return extractData(api.tenants({ id }).projects.get());
};

export const getTenantProjectsQueryOptions = (id: Tenant['id']) =>
  queryOptions({
    queryKey: ['tenants', id, 'projects'],
    queryFn: () => getTenantProjects(id),
    enabled: Boolean(id),
  });

export const useTenantProjects = (id: Tenant['id']) => {
  return useQuery(getTenantProjectsQueryOptions(id));
};

const createTenantProject = ({
  tenantId: id,
  ...args
}: CreateProjectType & { tenantId: Tenant['id'] }) => {
  return extractData(api.tenants({ id }).projects.post(args));
};

export const useCreateTenantProject = ({ mutationConfig }: CreateTenantProjectOptions) => {
  return useMutation({ ...mutationConfig, mutationFn: createTenantProject });
};
